import { UIModeSelectorDetailsController } from '../../../../../../shared/scripts/ui_html/home_page/UIModeSelectorDetailsController.ts';
export class UIMModeSelectorDetailsController extends UIModeSelectorDetailsController {
    onShow() {
        this.previousScene = this.sceneController.scene;
        this.sceneController.loadScene(undefined);
    }
    onHide() {
        const previousScene = this.previousScene;
        this.hideAndClearPreviousScene();
        this.sceneController.loadScene(previousScene);
    }
    hideAndClearPreviousScene() {
        this.previousScene = undefined;
        this.detailsContainer.classList.add('hidden');
    }
    constructor(onStartGame, onRedirectToCasual, sceneController){
        super(onStartGame, onRedirectToCasual);
        this.sceneController = sceneController;
        this.detailsContainer.classList.add('mm-details-mobile');
    }
}
